import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';

export default class HeroComponent extends Component {

  get SELECTORS() {
    return {
      heroContainer: '[data-hero-container]',
      heroVideo: '[data-hero-video]',
      brigthcoveWrapper: '.brightcove-wrapper'
    }
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.heroContainer = document.querySelector(this.SELECTORS.heroContainer);
  }


  stylizeOneMediaVideo() {
    let heroClasses = this.heroContainer.classList;
    if (heroClasses.contains('--one-media') && heroClasses.contains('--is-video')) {
      //if video exists
      let videoWrapper = this.heroContainer.querySelector(this.SELECTORS.brigthcoveWrapper);
      let heroVideo = this.heroContainer.querySelector(this.SELECTORS.heroVideo);
      if (videoWrapper != null && heroVideo != null) {
        let aspectRatioData = isMobile(MobileBreakpoint.Max767) ?
          videoWrapper.getAttribute('data-aspectratio-mobile') :
          videoWrapper.getAttribute('data-aspectratio');

        let aspectRatio = aspectRatioData.split(':').map(Number);
        //brightcove-loader calc
        let paddingBottom = aspectRatio[1] / aspectRatio[0] * 100;

        heroVideo.style.paddingBottom = paddingBottom + '%';
      }
    }
  }

  render() {
    super.render();
    this.stylizeOneMediaVideo();
  }
}
